import storage from '@utils/storage/storage'
import Cookies from 'js-cookie'
// NCIClogo
import ncicLogo from '@res/images/logo/schooLogo.png'
// NCPClogo
import ncpaLogo from '@res/images/logo/ncpaulc_logo.png'
// saas logo
import saasLogo from '@res/images/logo/saasLogo.png'

import axios from 'axios'
import envMode from '@/utils/ajax/http'

export default {
  data () {
    return {
      ncicLogo,
      ncpaLogo,
      saasLogo
    }
  },
  methods: {
    // 是否有MomentsMarketing角色
    isMoMa () {
      // Moments_Marketing \ System_Admin
      let tokenInfo = Cookies.get('tokenInfo') ? JSON.parse(Cookies.get('tokenInfo')) : {}
      let roles = tokenInfo.roles || []
      let control = false
      const systemAdmin = !!roles.find((item) => {
        return item === 'System_Admin'
      })

      const momentsMarketing = !!roles.find((item) => {
        return item === 'Moments_Marketing'
      })
      // 当Moments_Marketing和System_Admin出现在一起的时候，System_Admin优先
      if (systemAdmin && momentsMarketing) {
        control = false
        // 当Moments_Marketing和“其他权限”在一起的时候出现在一起的时候，Moments_Marketing优先
      } else if (!systemAdmin && momentsMarketing) {
        control = true
      }

      return control
    },
    // 获取Token
    getUserToken () {
      return Cookies.get('userToken')
    },
    // 获取用户信息
    getUserInfo () {
      let userInfo = this.$Storage.get('userInfo') || ''
      return userInfo
    },
    // 切换语言
    switchLang () {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
      localStorage.setItem('lang', this.$i18n.locale)
    },
    logout () {
      let accountType = this.getAccountType()
      this.$request.delete('/auth-service/authentication/logout').then(res => {
        storage.clearAll()
        // window.localStorage.clear()
        window.sessionStorage.clear()
        Cookies.remove('Authorization', { domain: envMode.env.DOMAIN })
        Cookies.remove('clientApp', { domain: envMode.env.DOMAIN })
        Cookies.remove('outTime', { domain: envMode.env.DOMAIN })
        Cookies.remove('tokenInfo', { domain: envMode.env.DOMAIN })
        Cookies.remove('userInfo', { domain: envMode.env.DOMAIN })
        window.location.href = `${window.location.origin}${accountType === 1 ? '/parentLogin' : '/login'}`
      })
    },
    // 获取orgId orgName
    selectOrganizationByAddress () {
      let hf = process.env.API_ROOT
      if (hf) {
        hf = hf.split('//')
      }
      hf = hf[1].split('.')
      let address = hf[0]
      if (!storage.get(process.env.API_ROOT)) {
        this.$request.get('/authorize-service/authorize/organization/selectOrganizationByAddress/', {
          address: address
        }).then(res => {
          storage.set(process.env.API_ROOT, res.data)
        })
      }
    },
    findUserRole (userId) {
      this.$request.get('/authorize-service/authorize/service/userRelation/findUserRole', {
        operateId: userId
      }).then(res => {
        storage.set('role', res.data)
      })
    },
    //  判断不同环境展示不同logo
    theLogo () {
      let env = process.env.NODE_ENV
      if (env === 'production') { // saas
        return {
          logoImg: this.saasLogo
        }
      } else if (env === 'ncic') {
        return {
          logoImg: this.ncicLogo
        }
      // } else if (env === 'ncpa') {
      } else {
        return {
          logoImg: this.ncpaLogo
        }
      }
    },
    /**
     * @获取账号类型 // 0 老师1 家长2 学生3 内部
     */
    getAccountType () {
      let userInfo = Cookies.get('tokenInfo') ? JSON.parse(Cookies.get('tokenInfo')) : ''
      return userInfo.accountType
    },
    curLang () {
      return Cookies.get('lang') === 'zh'
    },
    // 邮箱校验
    validateEmail (str) {
      const reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return reg.test(str)
    },
    // 日期时间格式化
    parseTime (time, cFormat = '{y}-{m}-{d}') {
      if (time === '-- --') return time
      if (arguments.length === 0) {
        return null
      }
      const format = cFormat || '{y}-{m}-{d}' || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        enm: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const timestr = format.replace(/{(y|m|enm|d|h|i|s|a)+}/g, (result, key) => {
        const lang = localStorage.getItem('lang') || 'en_US'
        let value = formatObj[key]
        if (lang === 'en_US') {
          if (key === 'a') return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][value - 1]
          if (key === 'enm') return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][value - 1]
        } else {
          if (key === 'a') return ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'][value - 1]
          if (key === 'enm') return ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'][value - 1]
        }
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return timestr
    },

    // 获取url参数
    getQueryString (name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
      const r = window.location.search.substr(1).match(reg)// search,查询？后面的参数，并匹配正则
      if (r != null) return unescape(r[2]); return null
    },

    // 是否开始维护
    hasMaintain (type = 0) {
      // 0-代表全局；1-招生；2-家校互动；3-直播；4-备课
      return new Promise(async (resolve, reject) => {
        let isContinue = true
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') resolve(isContinue)
        axios.get(`${envMode.env.MAINTAIN_URL}/systemConfig/systemUpgrade/${type}/0`).then((res) => {
          console.log(res)
          // 1: 未维护 0: 维护中
          if (res.data.status === 0) {
            sessionStorage.setItem('maintainInfo', JSON.stringify(res.data))

            isContinue = false
          }

          resolve(isContinue)
        }).catch((error) => {
          resolve(isContinue)
          console.log(error) // 异常
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js